import { RECURRING_PERIODS } from 'lib/stripe';
import { useSession } from 'next-auth/react';
import PropTypes from 'prop-types';
import {
  BankAccountPropType,
  CardPaymentMethodPropType,
  CashAppPropType,
  LinkPropType,
  PricesPropType,
} from 'utilities/propTypes';
import { PersonSummary } from './PersonSummary';
import SubscriptionForm from './SubscriptionForm';

const BuyPremium = ({
  prices,
  customer,
  paymentMethod,
  clientSecret = null,
}) => {
  const { data: session } = useSession();

  // Must be logged in, have located a Customer, and not have an active subscription
  const canSubscribe =
    session?.user?.id && customer && !customer?.subscription?.active;

  return canSubscribe ? (
    <SubscriptionForm
      prices={prices}
      clientSecret={clientSecret}
      customer={customer}
      paymentMethod={paymentMethod}
    />
  ) : (
    <PersonSummary
      customer={customer}
      paymentMethod={paymentMethod}
      user={session?.user}
    />
  );
};

BuyPremium.propTypes = {
  prices: PricesPropType,
  customer: PropTypes.shape({
    id: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    uuid: PropTypes.string.isRequired,
    subscription: PropTypes.shape({
      id: PropTypes.string.isRequired,
      active: PropTypes.bool.isRequired,
      cancelAt: PropTypes.number,
      currentPeriodEnd: PropTypes.number,
      plan: PropTypes.shape({
        id: PropTypes.string.isRequired,
        amount: PropTypes.number.isRequired,
        amountFormatted: PropTypes.string.isRequired,
        interval: PropTypes.oneOf([
          RECURRING_PERIODS.MONTH,
          RECURRING_PERIODS.YEAR,
        ]).isRequired,
      }).isRequired,
    }),
    billingPortalSession: PropTypes.string,
  }),
  paymentMethod: PropTypes.oneOfType([
    CardPaymentMethodPropType,
    BankAccountPropType,
    LinkPropType,
    CashAppPropType,
  ]),
  clientSecret: PropTypes.string,
};

export default BuyPremium;
